import { UA } from './util';
/**
 * Kugou 手机内嵌页通信接口v2.2
 * 异步回调方式
 *
 * @Module KgMobileCall
 *
 */

export var KgMobileCall_native = {
  /*库版本*/
  ver: '2.2',

  /**
   * 是否调试模式
   * 0 : 关闭
   * 1 ：console
   * 2 : alert
   */
  debug: 0,

  /*是否在安卓内嵌页*/
  isAndroid: typeof external == 'undefined' ? false : typeof external.superCall == 'undefined' ? false : true,

  /*是否在IOS内嵌页*/
  isIOS: navigator.userAgent.match(/KGBrowser/gi) ? true : false,
  chkAndroidApp: function chkAndroidApp() {
    try {
      if (external.superCall(122)) {
        return true;
      }
    } catch (ex) {
      return false;
    }
  },
  cbNum: 0,

  /*链接格式*/
  formatURL: {
    "browser": "",
    "url": ""
  },

  /*歌曲格式数据*/
  formatSong: {
    "filename": "",
    "filesize": "",
    "hash": "",
    "bitrate": "",
    "extname": "",
    "duration": "",
    "mvhash": "",
    "m4afilesize": "",
    "320hash": "",
    "320filesize": "",
    "sqhash": "",
    "sqfilesize": 0,
    "feetype": 0,
    "isfirst": 0
  },

  /*MV格式数据*/
  formatMV: {
    "filename": "",
    "singername": "",
    "hash": "",
    "imgurl": ""
  },

  /*分享数据*/
  formatShare: {
    "shareName": "",
    "topicName": "",
    "hash": "",
    "listID": "",
    "type": "",
    "suid": "",
    "slid": "",
    "imgUrl": "",
    "filename": "",
    "duration": "",
    "shareData": {
      "linkUrl": "",
      "picUrl": "",
      "content": "",
      "title": ""
    }
  },

  /**
   * 格式化数据,覆盖,1层递归
   * @param { Object } osrc，格式数据
   * @param { Object } src， 数据
   */
  _extend: function _extend(osrc, src) {
    var me = this;

    if (src) {
      for (var property in osrc) {
        if (!src.hasOwnProperty(property)) {
          src[property] = osrc[property];
        }
      }
    }

    return src;
  },

  /**
   * @method str2Json
   *
   * @param { String } jsonStr
   * @return { Object } json
   */
  str2Json: function str2Json(jsonStr) {
    var json = {};

    if (Object.prototype.toString.call(jsonStr) === "[object String]") {
      try {
        json = JSON.parse(jsonStr);
      } catch (ex) {
        json = {};
      }
    }

    return json;
  },
  json2Str: function json2Str(json) {
    var jsonStr = "";

    if (typeof json !== "string") {
      try {
        jsonStr = JSON.stringify(json);
      } catch (e) {
        jsonStr = "";
      }
    }

    return jsonStr;
  },
  loadUrl: function loadUrl(url) {
    var iFrame;
    iFrame = document.createElement("iframe");
    iFrame.setAttribute("src", url);
    iFrame.setAttribute("style", "display:none;");
    iFrame.setAttribute("height", "0px");
    iFrame.setAttribute("width", "0px");
    iFrame.setAttribute("frameborder", "0");
    document.body.appendChild(iFrame);
    iFrame.parentNode.removeChild(iFrame);
    iFrame = null;
  },

  /**
   * 执行不返回数据的调用
   *
   * @method callCmd
   * @function
   * @param { Object } {cmd:Number(命令号),jsonStr:String(参数),callback:Function(回调函数)}
   * @return void(0)
   */
  callCmd: function callCmd(o) {
    var me = this,
        iosApi = "",
        res,
        dc = document; //debug

    if (dc.getElementById('mod_debugwin_set')) {
      dc.getElementById('mod_debugwin_set').innerHTML = JSON.stringify(o).replace(/\\/g, '');
    }

    if (me.debug > 0) {
      switch (me.debug) {
        case 1:
          if (window.console) {
            console.log(o);
          }

          break;

        case 2:
          alert(JSON.stringify(o).replace(/\\/g, ''));
          break;

        default:
          break;
      }
    }

    if (me.chkAndroidApp()) {
      try {
        if (o.jsonStr) {
          res = external.superCall(o.cmd, o.jsonStr);
        } else {
          res = external.superCall(o.cmd);
        }

        if (o.callback && o.callback !== '') {
          res = me.str2Json(res);
          o.callback(res);
        }
      } catch (ex) {}
    } else if (me.isIOS) {
      if (o.callback) {
        me.cbNum++;
        var cbName = "kgmobilecall" + me.cbNum + Math.random().toString().substr(2, 9);
        /*创建随机函数*/

        window[cbName] = function (res) {
          if (typeof res != 'undefined') {
            if (o.callback) {
              if (Object.prototype.toString.call(res) === '[object String]') {
                o.callback(me.str2Json(res));
              } else {
                o.callback(res);
              }
            }
          } //delete window[cbName];

        };

        if (o.jsonStr) {
          iosApi = 'kugouurl://start.music/?{"cmd":' + o.cmd + ', "jsonStr":' + o.jsonStr + ', "callback":"' + cbName + '"}';
        } else {
          iosApi = 'kugouurl://start.music/?{"cmd":' + o.cmd + ', "callback":"' + cbName + '"}';
        }
      } else {
        if (o.jsonStr) {
          iosApi = 'kugouurl://start.music/?{"cmd":' + o.cmd + ', "jsonStr":' + o.jsonStr + '}';
        } else {
          iosApi = 'kugouurl://start.music/?{"cmd":' + o.cmd + '}';
        }
      } //location.href = iosApi;


      me.loadUrl(iosApi);
    } else {
      if (o.callback) {
        o.callback({
          "status": 0,
          "error": "不在客户端内"
        });
      }
    }
  },

  /**
   * 获取当前酷狗客户端版本号
   *
   * @method getVersion
     * @param { String } callback
   */
  getVersion: function getVersion(callback) {
    this.callCmd({
      cmd: 122,
      callback: callback
    });
  },

  /**
   * 获取当前酷狗端内信息
   *
   * @method getMobileInfo
     * @param { String } callback
   */
  getMobileInfo: function getMobileInfo(callback) {
    this.callCmd({
      cmd: 124,
      callback: callback
    });
  },

  /**
   * 分享歌曲/专辑/歌单
   *
   * @method share
   * @function
   * @param { Object } JSON参数
   * @param { Function } iosCallback
   * @param { Function } weixinCallback 如果此参数为空时，在非客户端非微信的情况下就会调用新浪分享，不为空时就会调用此callback。。。
   * @param { Function } otherCallback 其他回调
   * @return
   */
  share: function share(json, iosCallback, weixinCallback, otherCallback) {
    var me = this,
        jsonStr = "",
        info = {},
        ua = navigator.userAgent,
        _wbShare = function _wbShare() {
      var option = {
        title: encodeURIComponent(json.shareData.title) || "",
        url: json.shareData.linkUrl || "",
        content: encodeURIComponent(json.shareData.content) || "",
        imgSrc: encodeURI(json.shareData.picUrl) || "",
        swf: "",
        appkey: "340086183",

        /*(新浪微博) 用参数,关联用户的UID，分享微博会@该用户(可选)*/
        ralateUid: ""
      },
          winSrc = "",
          queryStr = "";
      winSrc = "http://service.t.sina.com.cn/share/share.php";
      queryStr = ["url=" + option.url, "appkey=" + option.appkey, "title=" + option.content, "pic=" + option.imgSrc, "ralateUid=" + option.ralateUid].join("&");
      location.href = winSrc + "?" + queryStr;
    };

    if (json) {
      info = me._extend(me.formatShare, json);
      json = info;
    } //TODO


    if (me.isIOS) {
      if (iosCallback) {
        me.callCmd({
          cmd: 115,
          jsonStr: me.json2Str(json),
          callback: iosCallback
        });
      } else {
        me.callCmd({
          cmd: 115,
          jsonStr: me.json2Str(json)
        });
      }
    } else if (me.chkAndroidApp()) {
      me.getVersion(function (res) {
        me.getMobileInfo(function (mobileInfo) {
          var isKugouAndroid = mobileInfo && Number(mobileInfo.appid || mobileInfo.appId) === 1005;

          if (isKugouAndroid && res && json && json.type == 3 && res.platform == "android" && Number(res.version) < 6340) {
            _wbShare();
          } else {
            me.callCmd({
              cmd: 115,
              jsonStr: me.json2Str(json)
            });
          }
        });
      });
    } else if (UA.isWeiXin || UA.isMobileQQ) {
      if (weixinCallback) {
        weixinCallback();
      } else {
        _wbShare();
      }
    } else {
      if (otherCallback) {
        otherCallback();
      } else {
        _wbShare();
      }
    }
  },
  multiShare: function multiShare(json, callback) {
    var me = this,
        jsonStr = "";
    jsonStr = me.json2Str(json);

    if (callback) {
      me.callCmd({
        cmd: 294,
        jsonStr: jsonStr,
        callback: callback
      });
    } else {
      me.callCmd({
        cmd: 294,
        jsonStr: jsonStr
      });
    }
  },

  /**
   * 是否在客户端里面
   *
   * @method isClient
   * @function
   * @return
   */
  isInClient: function isInClient() {
    var me = this;

    if (me.isAndroid || me.isKugouAndroid) {
      return true;
    } else if (me.isIOS) {
      return me.isIOS;
    } else {
      return false;
    }
  },
  shareMiniProgram: function shareMiniProgram(json) {
    var me = this,
        jsonStr = "";
    jsonStr = me.json2Str(json);
    me.callCmd({
      cmd: 269,
      jsonStr: jsonStr
    });
  }
};